module.exports = __webpack_public_path__ + "static/media/RobinCare_logo_symbol_Favicon copy 2.7b4becd9.png";